import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { AccountingRange } from 'src/features/accountingRanges/utils/types';

const RESOURCE = '/financial-documents/accounting-range/';

type QueryFnType = typeof queryFn;

interface DTO extends ListDTO {
    billing_entity?: string;
}

const queryFn = ({ ...params }: DTO): Promise<ListResponseAPI<AccountingRange>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as LIST_ACCOUNTING_RANGES_RESOURCE, useQueryHook as useListAccountingRanges };
